import type { HelpFile } from '../../types/help'
import { ApprovalPolicyCreateTestIds } from '../../../testids/ApprovalPolicyCreateTestIds'

export const approvalPolicyCreateHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyCreateTestIds.approvalPolicyCreatePage]:
      'Create a new approval policy. Pick the policy type, define matching conditions, and add the ordered approval steps that requests must go through.',
  },
}
